import { createTraitsSelector } from '@atlassian/jira-traits/src/TraitsStore.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const isFirstActiveWithinXDays = (firstActiveDate: string, xDays: number): boolean => {
	const date = new Date(firstActiveDate);
	if (Number.isNaN(date.getTime())) {
		return false;
	}
	const xDaysAgo = new Date();
	xDaysAgo.setDate(xDaysAgo.getDate() - xDays);
	// Set milliseconds to the same as the date to avoid timing issues, remove this will fail the unit test
	xDaysAgo.setMilliseconds(date.getMilliseconds());
	return date >= xDaysAgo;
};

export const useIsJiraUserFirstActiveWithinXDaysTraitSelector = (xDays: number) =>
	createTraitsSelector<'SITE_USER'>('SITE_USER', ({ getTraitByName }) => {
		if (!fg('jira_ybr_precondition_check_rollout_cross_flow')) {
			return false;
		}

		const firstActiveTrait = getTraitByName('jira_first_active');

		if (!firstActiveTrait || !(typeof firstActiveTrait.value === 'string')) {
			return false;
		}

		if (isFirstActiveWithinXDays(firstActiveTrait.value, xDays)) {
			return true;
		}

		return false;
	})();
